import axios from 'axios';
import { $, endPoint, findTarget, dataExist, loading } from '../utils/Utils';

const search = (() => {
  const triggers = [...$('.js-search')];
  const targetCN = 'js-searchTarget';
  const parent = 'js-searchParent';

  const createMarkup = data => `
    <p class="search__count">Din sökning gav ${data.count} träffar</p>
    <ul class="listSearch">
    ${data.results.map((result, i) => {
      let template = `<li class="listSearch__listItem"  style="animation-delay: ${i * 100}ms;">`;
      switch (result.category.toLowerCase()) {
        case 'nyheter':
        case 'sidor':
          template += `<article class="search__item">
                        ${(dataExist(result, 'category')) ? `<span class="label">${result.category}</span>` : ''}
                        ${(dataExist(result, 'title')) ? `<h1 class="title">${(dataExist(result, 'link')) ? `<a href="${result.link}">` : ''}${result.title}${(dataExist(result, 'link')) ? '</a>' : ''}</h1>` : ''}
                        ${(dataExist(result, 'content')) ? `<div class="fm">${result.content}</div>` : ''}
                      </article>`;
          break;
        case 'återförsäljare':
          template += `<article class="search__item">
                        ${(dataExist(result, 'category')) ? `<span class="label">${result.category}</span>` : ''}
                        ${(dataExist(result, 'title')) ? `<a href="/kontakt/?place=${result.id}" target="_blank"><h1 class="title">${result.title}</h1></a>` : ''}
                        <div class="fm">
                          ${(dataExist(result, 'phone') || dataExist(result, 'email')) ? `
                            <div class="officeDetails__contact" style="padding: 0;">
                              <h4 class="title">Kontakt:</h4>
                              ${(dataExist(result, 'phone')) ? `<p><a href="tel:${result.phone}">${result.phone}</a></p>` : ''}
                              ${(dataExist(result, 'email')) ? `<p><a href="mailto:${result.email}">${result.email}</a></p>` : ''}
                            </div>` : ''}
                          ${(dataExist(result, 'address') || dataExist(result, 'zip') || dataExist(result, 'city')) ? `
                            <div class="officeDetails__contact" style="padding: 0;">
                              <h4 class="title">Postadress:</h4>
                              <p>
                                ${(dataExist(result, 'address')) ? `${result.address}<br>` : ''}
                                ${(dataExist(result, 'zip')) ? `${result.zip} ` : ''}
                                ${(dataExist(result, 'city')) ? `${result.city} ` : ''}
                              </p>
                            </div>
                          ` : ''}
                        </div>
                      </article>`;
          break;
        case 'personal':
          template += `<article class="search__item">
                        ${(dataExist(result, 'category')) ? `<span class="label">${result.category}</span>` : ''}
                        ${(dataExist(result, 'title')) ? `<h1 class="title">${(dataExist(result, 'link')) ? `<a href="${result.link}">` : '<strong>'}${result.title}${(dataExist(result, 'link')) ? '</a>' : '</strong>'}</h1>` : ''}
                        ${(dataExist(result, 'phone')) ? `<div class="fm">${result.phone}` : ''}
                        ${(dataExist(result, 'email')) ? `<br><a href="mailto:${result.email}">E-postadress</a>` : ''}
                        ${(dataExist(result, 'phone') || (dataExist(result, 'email'))) ? '</div>' : ''}
                      </article>`;
          break;
        default:
          template = '';
          break;
      }
      template += '</li>';
      return template;
    }).join('')}
    </ul>`;

  const handleSuccess = ({ target, response }) => {
    target.innerHTML = createMarkup(response.data);
  };

  const handleSubmit = (e, trigger) => {
    const target = findTarget({ element: trigger, parent, target: targetCN });
    const formData = new FormData(trigger);

    loading.show(target);
    e.preventDefault();

    axios
      .post(endPoint.search, formData)
      .then((response) => { // response
        loading.stop(target);
        handleSuccess({ target, response });
      });
  };

  const build = () => {
    triggers.forEach((trigger) => {
      trigger.addEventListener('submit', e => handleSubmit(e, trigger));
    });
  };

  const init = () => {
    if (triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

search.init();

export default search;



// WEBPACK FOOTER //
// ./components/search.js